<template>
  <div class="border">
    <div class="menu">
        <input :id="`acd-check${menuId}`" class="acd-check" type="checkbox">
        <label class="acd-label" :for="`acd-check${menuId}`"><a class="acd-label-hover">{{ menuTitle }}</a></label>
        <div class="acd-content">
            <slot></slot>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuTitle: {
      type: String
    },
    menuId: {
      type: String
    }
  }
}
</script>